import { QueryConstraint, Unsubscribe } from "firebase/firestore";
import StoreCategory from "../entities/stores/category";
import FirestorePipe from "../utils/pipe";
import EstablishmentDB from "./establishment";
import StoreDB from "./store";

class StoreCategoriesComplementDB extends FirestorePipe {

  public static readonly colName = 'CategoriesComplement'

  constructor(idEstab: string, idStore: string) {
    if(!idEstab)
      throw new Error('Informe o id do estabelecimento')
    super(`${EstablishmentDB.colName}/${idEstab}/${StoreDB.colName}/${idStore}/${StoreCategoriesComplementDB.colName}`);
  }

  public define(id: string, data: StoreCategory): Promise<any> {
    return this._define(id, data);
  }
  public create(data: StoreCategory): Promise<any> {
    return this._create(data);
  }
  public update(id: string, data: StoreCategory): Promise<any> {
    return this._update(id, data);
  }
  public delete(id: string): Promise<any> {
    return this._delete(id);
  }
  public getAll(...params: QueryConstraint[]): Promise<StoreCategory[]> {
    return this._getAll<StoreCategory>(...params);
  }
  public get(id: string): Promise<StoreCategory> {
    return this._get(id);
  }
  public on(listener: (data: StoreCategory[]) => void, ...params: QueryConstraint[]): Unsubscribe {
    return this._on(listener, ...params);
  }

}

export default StoreCategoriesComplementDB;